export enum DasqlOperation {
  AND = '&',
  OR = '|',
  NOT = '!'
}
